export default "__VITE_ASSET__DN65cCJb__"